export enum PaymentsAccountVerificationStatus {
    NotRequired = 'NotRequired',
    Required = 'Required',
    PendingVerification = 'PendingVerification',
    Verified = 'Verified',
}

export class PaymentsAccountDetails {
    constructor(
        public chargesEnabled: boolean,
        public verificationStatus: PaymentsAccountVerificationStatus | null = null,
        public accountSignupLink: string | null = null
    ) { }
}
